export const GROUPS = {
  patients: ['patients'],
  appointments: ['appointments', 'appointment_services'],
  organization: ['branches', 'business_units', 'departments', 'workplaces'],
  stages: ['appointment_stages'],
  dictionaries: [
    'staff',
    'services',
    'appointment_reasons',
    'destination_types',
    'resources',
    'specializations',
    'diagnoses',
    'patient_statuses',
    'financial_sources',
    'payment_categories',
    'advertisements',
    'financial_sectors',
    'service_sections',
  ],
};

const COLUMNS = {
  patients: [
    'lastname',
    'name',
    'secondname',
    '$patient_phones',
    'mis_id',
    'birthday',
    'cardnumber',
    'is_archive',
  ],
  patient_phones: ['mis_id', 'phone', 'type'],
  appointments: [
    'mis_id',
    'planned_start_at',
    'to_contacts_mis_id',
    'doctor_lastname',
    'doctor_name',
    'to_branches_mis_id',
    'to_deals_stages_mis_id',
    'is_cancelled',
  ],
  appointment_services: [
    'mis_id',
    'to_deals_mis_id',
    'to_contacts_mis_id',
    'to_products_name',
    'quantity',
    'price',
    'discount_sum',
  ],
  workplaces: [
    'mis_id',
    'name',
    'to_branches_mis_id',
    'room_name',
    'room_number',
    'is_common',
  ],
  staff: [
    'mis_id',
    'lastname',
    'name',
    'secondname',
    'position',
    'is_dismissed',
  ],
  services: [
    'mis_id',
    'name',
    'price',
    'currency',
    'to_specializations_mis_id',
  ],
};

export const columnsFor = (entity, fields) => {
  const names = COLUMNS[entity] || [
    'mis_id',
    'name',
    'type_name',
    'to_branches_mis_id',
    'mkbcode',
    'group_name',
  ];
  // ID and MIS number are rendered as the two leading columns. Keep every
  // remaining source field, ordering operational fields first, never hiding any.
  const available = fields.filter(
    field => !['id', 'mis_number'].includes(field.name)
  );
  if (entity === 'patients') available.push({ name: '$patient_phones' });
  const leading = names
    .map(name => available.find(field => field.name === name))
    .filter(Boolean);
  return [
    ...leading,
    ...available.filter(field => !names.includes(field.name)),
  ];
};

export const groupFor = entity =>
  Object.keys(GROUPS).find(group => GROUPS[group].includes(entity));
